import 'moment-timezone';
import 'moment/locale/pt-br';

import { useEffect } from 'react';

import Providers from './data/providers/Providers';
import ErrorBoundary from './errors/boundary/ErrorBoundary';
import Router from '@/routes/Router';
import { initGA } from './utils/analytics';
import UpdateNotificationSW from './components/update/UpdateNotificationSW';
import ToastContainer from './components/toast/ToastContainer';

function App() {
  useEffect(() => {
    if (import.meta.env.MODE === 'production') initGA();
  }, []);

  return (
    <ErrorBoundary>
      <Providers>
        <ToastContainer />

        <UpdateNotificationSW />

        <Router />
      </Providers>
    </ErrorBoundary>
  );
}

export default App;
